"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploaderForm = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _reactHookForm = require("react-hook-form");
var _Localization = require("../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _contexts = require("../../contexts");
var _hooks = require("../../hooks");
var _interfaces = require("../../interfaces");
var _models = require("../../models");
var _api = require("../../models/api");
var _utils = require("../../utils");
var _Loading = require("../Loading");
var _FileInputField = require("./FileInputField");
var _jsxRuntime = require("react/jsx-runtime");
const bytesInKb = 1024;
const RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  position: 'relative',
  width: '100%'
}));
const UploadButtonWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  textAlign: 'center'
}));
const UploadButton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  maxWidth: '330px',
  width: '100%'
}));
const triggerFileUploadFinished = (result, onFileUploadedProp) => {
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- is not always truthy
  if (onFileUploadedProp && result) {
    onFileUploadedProp(result);
  }
};
const mapToFileUploadResult = (response, file, fileKey) => {
  let fileUploadResult = {
    file,
    fileKey,
    isSuccess: false
  };
  if (typeof response === 'number') {
    fileUploadResult = {
      ...fileUploadResult,
      documentId: response,
      isSuccess: true
    };
  } else if (response.errors?.length) {
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain, @typescript-eslint/no-unnecessary-condition -- needed this condition
    const code = response && response.errors && response.errors[0] && response.errors[0].code;
    const message = (0, _utils.getErrorLocalizationByCode)(code);
    fileUploadResult = {
      ...fileUploadResult,
      message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: message.id,
        defaultMessage: message.defaultMessage
      })
    };
  } else {
    fileUploadResult = {
      ...fileUploadResult,
      message: response.message
    };
  }
  return fileUploadResult;
};
const maxFileSizeError = (maxFileSizeProp, file) => {
  if (maxFileSizeProp && file && file.size > maxFileSizeProp) {
    return true;
  }
  return false;
};
const UploaderForm = props => {
  const {
    accept,
    isMultiple,
    children,
    handleFileChanged,
    handleUploadStart: onUploadStart,
    handleFileUploaded: onFileUploaded,
    handleUploadFinished: onUploadFinished,
    maxFileSize,
    documentTypeId,
    isTemporary,
    isRequired,
    inputName
  } = props;
  const inputRef = (0, _react.useRef)();
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const {
    data: registrationData
  } = (0, _api.useRegistrationData)();
  const {
    data: documentsInfoData
  } = (0, _api.useCustomerDocumentsInfos)();
  const customerId = registrationData?.customerId ?? null;
  const headers = (0, _hooks.useCustomHeaders)();
  const {
    notificationData
  } = (0, _contexts.useNotificationData)();
  const {
    setNotificationData
  } = notificationData;
  const api = (0, _globalApiClientReact.useApiClient)();
  const handleClick = () => {
    if (inputRef.current) {
      inputRef.current.value = '';
      inputRef.current.click();
    }
  };
  const getInputRef = element => {
    inputRef.current = element;
    if (props.inputRef) {
      props.inputRef(element);
    }
  };
  const createDocument = async (customerIdProperty, requestBody, requestOptions) => {
    try {
      const response = await (0, _globalApiClientReact.createCustomerDocument)(api, customerIdProperty, requestBody, requestOptions, headers, {
        timeout: 300000
      });
      return new _models.FetchResult(response.status, response.data);
    } catch (error) {
      setNotificationData({
        isOpen: true,
        message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.cannotCreate,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.cannotCreate
        }),
        type: _interfaces.MessageType.error
      });
    }
    return _models.FetchResult.error;
  };
  const deleteDocument = async (customerIdProperty, documentId) => {
    try {
      const response = await (0, _globalApiClientReact.deleteCustomerDocument)(api, customerIdProperty, documentId, headers);
      const result = new _models.FetchResult(response.status);
      return result;
    } catch (error) {
      setNotificationData({
        isOpen: true,
        message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.cannotDelete,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.cannotDelete
        }),
        type: _interfaces.MessageType.error
      });
    }
    return _models.FetchResult.error;
  };
  const replaceDocument = async (customerIdProperty, oldDocumentId, requestBody, newDocumentRequestOptions) => {
    let deleteResult;
    try {
      deleteResult = await deleteDocument(customerIdProperty, oldDocumentId);
      if (deleteResult.isSuccess()) {
        return await createDocument(customerIdProperty, requestBody, newDocumentRequestOptions);
      }
      return _models.FetchResult.error;
    } catch (error) {
      setNotificationData({
        isOpen: true,
        message: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
          id: _models.TranslationKey.cannotCreate,
          defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.cannotCreate
        }),
        type: _interfaces.MessageType.error
      });
    }
    return _models.FetchResult.error;
  };
  const button = /*#__PURE__*/(0, _jsxRuntime.jsx)(UploadButton, {
    fullWidth: true,
    variant: "outlined",
    color: "primary",
    ...getTestIdProps('uploader-form-btn-upload'),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
      id: _models.TranslationKey.ThirdStep_SelectFile,
      defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_SelectFile
    })
  });
  const requestOptions = (0, _react.useMemo)(() => ({
    documentTypeId,
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing --- we want specify undefined
    isTemporary: isTemporary === undefined ? true : isTemporary
  }), [documentTypeId, isTemporary]);
  const [lastOfType] = (0, _react.useMemo)(() => documentsInfoData?.filter(info => {
    const isTemporaryDocument = false;
    return info.documentTypeId === documentTypeId && (!info.isTemporary || isTemporaryDocument);
  }).sort((a, b) => {
    if (a.createdDate.getTime() && b.createdDate.getTime()) {
      return a.createdDate.getTime() - b.createdDate.getTime();
    }
    return 0;
  }) ?? [], [documentTypeId, documentsInfoData]);
  const fileMapper = async (file, key, customerIdProperty, result) => {
    const negativeOne = -1;
    const fileKey = (key + 1) * negativeOne;
    requestOptions.documentTypeId = documentTypeId;
    if (maxFileSize && maxFileSizeError(maxFileSize, file)) {
      const maxMBs = Math.ceil(maxFileSize / bytesInKb / bytesInKb);
      const errorMessage = /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.selectedFileExceedsMaximumSize,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.selectedFileExceedsMaximumSize,
        values: {
          maxMBs
        }
      });
      const fileResult = {
        file,
        fileKey,
        isSuccess: false,
        message: errorMessage
      };
      triggerFileUploadFinished(fileResult, onFileUploaded);
      return;
    }
    let fetchResult;
    if (isTemporary === false && lastOfType?.documentId && !isMultiple) {
      fetchResult = await replaceDocument(customerIdProperty, lastOfType.documentId, {
        file
      }, requestOptions);
    } else {
      fetchResult = await createDocument(customerIdProperty, {
        file
      }, requestOptions);
    }
    if (fetchResult.response) {
      const fileResult = mapToFileUploadResult(fetchResult.response, file, fileKey);
      triggerFileUploadFinished(fileResult, onFileUploaded);
      result.uploadedFiles.push(fileResult);
    }
  };
  const handleChangeFile = async (files, field, customerIdProperty) => {
    if (handleFileChanged && files[0] !== undefined) {
      handleFileChanged(files[0]);
    }
    if (files.length > 0 && onUploadStart) {
      onUploadStart(files);
    }
    const result = {
      uploadedFiles: []
    };
    // eslint-disable-next-line unicorn/prefer-spread -- we want this writing
    const uploadPromises = Array.from(files).map(async (file, key) => fileMapper(file, key, customerIdProperty, result));
    await Promise.all(uploadPromises);
    if (onUploadFinished) {
      field.onChange(result.uploadedFiles);
      onUploadFinished(result);
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(RootContainer, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.Controller, {
      name: inputName,
      rules: {
        required: isRequired
      },
      render: ({
        formState,
        field
      }) => /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.FormControl, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FileInputField.FileInputField, {
          name: inputName,
          accept: accept,
          inputRef: getInputRef,
          isMultiple: isMultiple,
          onChange: e => {
            const {
              files
            } = e.target;
            if (files?.length && customerId) {
              handleChangeFile(files, field, customerId);
            }
          }
        }), formState.isSubmitting ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loading.Loading, {}) : null]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(UploadButtonWrapper, {
      onClick: handleClick,
      children: children ?? button
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "caption",
      color: "textSecondary",
      textAlign: "center",
      display: "block",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.ThirdStep_DocumentFileSize,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.ThirdStep_DocumentFileSize
      })
    })]
  });
};
exports.UploaderForm = UploaderForm;